import { API_BASE_URL } from "../../config";
import React, { useState, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

const ProfilePictureUpload = () => {
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const navigate = useNavigate();

    // Function to check token from localStorage (same as in AdminRegister)
    const checkToken = useCallback(() => {
        const user = localStorage.getItem("user");
        if (!user) {
            navigate("/login");
            return null;
        }
        return JSON.parse(user)?.token;
    }, [navigate]);

    // Handle file selection and preview generation
    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        setPreview(URL.createObjectURL(selectedFile)); // Generate preview for the selected file
    };

    // Handle the file upload
    const handleUpload = async () => {
        if (!file) {
            alert("Please select a file first.");
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        // Get token using the checkToken function
        const token = checkToken();
        if (!token) return; // If no token, stop the upload

        try {
            // Feature disabled: /api/Manager/ is no longer usable
            /*
            await axios.post(`${API_BASE_URL}/api/Manager/Store/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}` // Include the token in the Authorization header
                },
            });

            alert('File uploaded successfully!');
            */
           alert('Upload functionality is currently disabled.');
        } catch (error) {
            console.error("File upload failed:", error);
            alert('An error occurred during file upload.');
        }
    };

    return (
        <div>
            <input type="file" onChange={handleFileChange} />
            {preview && <img src={preview} alt="Profile Preview" style={{ width: '200px', marginTop: '10px' }} />}
            <button onClick={handleUpload}>Upload</button>
        </div>
    );
};

export default ProfilePictureUpload;
